import PropTypes from "prop-types";
import "../assets/css/components.css";

export const Textbox = ({
  name = "",
  type = "",
  placeholder = "",
  value = "",
  onChange = () => {},
  errorMsg,
  readOnly = false,
  isMandatory = true,
  isPlaceholderOnly = false,
}) => {
  const inputProps = {
    name,
    type,
    placeholder,
    value,
    onChange,
    readOnly,
  };

  return (
    <div className="wrapper">
      {!isPlaceholderOnly && (
        <label className="form-label">
          {placeholder}
          {!readOnly && isMandatory && (
            <span className="mandatory-field">*</span>
          )}
        </label>
      )}
      <input
        {...inputProps}
        className={`field ${readOnly ? "disabled" : ""}`}
        onChange={onChange}
      />
      {errorMsg && <span className="error-message">{errorMsg}</span>}
    </div>
  );
};

Textbox.propTypes = {
  name: PropTypes.string,
  type: PropTypes.any,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  errorMsg: PropTypes.any,
  readOnly: PropTypes.bool,
  isMandatory: PropTypes.bool,
  isPlaceholderOnly: PropTypes.bool,
};
